import { render } from "./Fields.vue?vue&type=template&id=15420704&scoped=true"
import script from "./Fields.vue?vue&type=script&lang=js"
export * from "./Fields.vue?vue&type=script&lang=js"

import "./Fields.vue?vue&type=style&index=0&id=15420704&scoped=true&lang=css"

import exportComponent from "/home/runner/work/rentapplication-frontend-vue/rentapplication-frontend-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15420704"]])

export default __exports__